import { captureException } from '@sentry/remix';
import {
  applyRSSFeedAttributesToCardStructure,
  BUILD_RSS_FEED_DEFAULT_CARD_STRUCTURE,
  type SerializableNode,
  type TContentGatePopupElement,
  type TRSSFeedElement,
} from '@shared/dream-components';
import type { WritableDraft } from 'immer';
import { produce } from 'immer';

export type ProcessorFunctionOptions = {
  publicationUrl?: string;
};

export type ProcessorFunction = (node: WritableDraft<SerializableNode>, options?: ProcessorFunctionOptions) => void;

export const processContentGatePopupNode = (node: TContentGatePopupElement, options?: ProcessorFunctionOptions) => {
  if (!options?.publicationUrl || !Array.isArray(node.content) || node.content.length === 0) {
    return node;
  }

  const replaceableURLS = ['http://the-way-of-all-flesh.localhiiv.com:3002/'];

  node.content = produce(node.content, (contentDraft: SerializableNode) => {
    try {
      let json = JSON.stringify(contentDraft);
      replaceableURLS.forEach((url) => {
        json = json.replaceAll(url, options?.publicationUrl as string);
      });
      return JSON.parse(json);
    } catch {
      return contentDraft;
    }
  });

  return node;
};

export const processRSSFeedNode = (node: TRSSFeedElement) => {
  if (!node || !node.attrs) {
    return node;
  }

  try {
    const isStructureTiptapStateDefined = Object.keys(node.attrs.structureTiptapState ?? {}).length > 0;

    if (isStructureTiptapStateDefined) {
      return node;
    }

    return produce(node, (nodeDraft: TRSSFeedElement) => {
      // * Force orchid to render card structure by casting the node attributes to the card structure
      //   if card structure does not already exist
      // * If a card structure already exists, it means it has been migrated to the new card structure
      //   via the website builder
      const cardStructure = applyRSSFeedAttributesToCardStructure(
        node.attrs,
        BUILD_RSS_FEED_DEFAULT_CARD_STRUCTURE({
          imageAspectRatio: node.attrs.source === 'youtube' ? 1.7777777777777777 : 1,
        }),
      );

      nodeDraft.attrs.hasMigratedToCardStructure = true;
      nodeDraft.attrs.structureTiptapState = cardStructure;

      return nodeDraft;
    });
  } catch (error) {
    captureException(error);
  }

  return node;
};

export const processors = {
  processContentGatePopupNode,
};
